import Vue from 'vue'

// Estado global do visualizador de mapa. Existe UMA única instância Mapbox na
// página inteira (dentro de MapViewer.vue), reaproveitada para qualquer mapa
// que o usuário abrir. Motivo: no ambiente alvo, só a PRIMEIRA instância Mapbox
// criada no ciclo de vida da página renderiza as camadas vetoriais (coroplético)
// — instâncias seguintes aparecem sem cor. Uma instância única e persistente é
// sempre "a primeira", então sempre colore.
export const mapViewerState = Vue.observable({
	open: false,
	geojson: null,
	seq: 0,
})

export function openMapViewer(geojson) {
	mapViewerState.geojson = geojson
	mapViewerState.seq += 1
	mapViewerState.open = true
}

export function closeMapViewer() {
	mapViewerState.open = false
}
